/**
 * Update all instances of .user-location & .user-city
 * @param {Object} geoData - response from /api/PostalCordinateInfo/{zip}/get
 */
export function populateLocationFieldsDynamically(geoData) {
	window.modForm.opts.userLocation = geoData.city + ', ' + geoData.state;
	const userLocation = document.querySelectorAll('.user-location:not(.reviews-block .user-location)');

	if (userLocation.length) {
		userLocation.forEach(function($userLocation) {
			if ($userLocation) {
				$userLocation.innerHTML = window.modForm.opts.userLocation;
			}
		});
	}

	if (document.querySelector('.user-city')) {
		document.querySelector('.user-city').innerHTML = geoData.city;
	}
}
